import React from "react";
import { CalendarDays, ExternalLink } from "lucide-react";
import { useApi } from "../hooks/useApi";
import { useLang } from "../i18n/LanguageContext";

function withViewOptions(url, scope) {
  try {
    const u = new URL(url);
    if (scope !== "admin") {
      u.searchParams.set("showProfileAndInfo", "0");
      u.searchParams.set("disableSidepanel", "1");
    }
    if (typeof window !== "undefined" && window.innerWidth < 768) {
      u.searchParams.set("showSidepanel", "0");
      if (!u.searchParams.get("view")) u.searchParams.set("view", "a");
    }
    return u.toString();
  } catch { return url; }
}

export function TeamupCalendar({ scope = "public", title = "Association calendar" }) {
  const { data } = useApi("/settings/calendar");
  const { t } = useLang();
  if (!data) return null;
  const url = scope === "admin" ? data.member_url : data.public_url;
  const enabled = scope === "admin" ? data.member_enabled : data.public_enabled;
  if (!enabled || !url) return null;
  const src = withViewOptions(url, scope);
  return (
    <div data-testid={`teamup-calendar-${scope}`}>
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <h2 className="flex items-center gap-2 font-serif-display text-2xl font-bold text-crimson"><CalendarDays size={22} className="text-gold" /> {t(title)}</h2>
        <a href={url} target="_blank" rel="noreferrer" className="inline-flex min-h-[40px] items-center gap-1 text-sm font-semibold text-palm hover:underline" data-testid={`teamup-open-${scope}`}>{t("Open full calendar")} <ExternalLink size={14} /></a>
      </div>
      <div className="glass overflow-hidden rounded-2xl">
        <iframe title={title} src={src} loading="lazy" style={{ width: "100%", height: Math.min(data.height || 600, window.innerWidth < 768 ? 520 : 1400), border: 0 }} data-testid={`teamup-iframe-${scope}`} />
      </div>
    </div>
  );
}
